/* eslint-disable no-param-reassign */
import Collection from "./Collection";

export default class Container extends Collection {

    /** @override */
    initEditor(props) {

        super.initEditor(props);
        props['data-editable-arrayable'] = '0';
    }

}